<template>

    <div class="my-6">

        <div class="my-3">
            <ListBoxSelectWithImage :options="typeMaterialCnc" v-model="form.typeMaterialCnc" labelMain="Material Type"
                requires="True" />
        </div>



        <div class="my-3">

            <ListBoxSelectWithImage v-if="form.typeMaterialCnc == 'Aluminum'" :options="typeMaterialCncAluminum"
                v-model="form.typeMaterialCncDependent" />

            <ListBoxSelectWithImage v-if="form.typeMaterialCnc == 'Cold Rolled Steel'"
                :options="typeMaterialCncColdRolledSteel" v-model="form.typeMaterialCncDependent" />

            <ListBoxSelectWithImage v-if="form.typeMaterialCnc == 'Hot Rolled Steel'"
                :options="typeMaterialCncHotRolledSteel" v-model="form.typeMaterialCncDependent" />

            <ListBoxSelectWithImage v-if="form.typeMaterialCnc == 'Stainless Steel'"
                :options="typeMaterialCncStainlessSteel" v-model="form.typeMaterialCncDependent" />

            <ListBoxSelectWithImage v-if="form.typeMaterialCnc == 'Plastic'" :options="typeMaterialCncPlastic"
                v-model="form.typeMaterialCncDependent" />
        </div>

        <div v-if="form.typeMaterialCnc == 'Other'">
            <BaseTextArea
                label="Please tell us about the material you require. We can source material as a non-stock request, for additional leadtime and cost. "
                v-model="form.typeMaterialCncOther"
                tooltip="We can source different material as a non-stock request, for additional leadtime and cost." />

        </div>

        <div v-if="form.typeMaterialCnc !== 'Plastic'" class="my-3">

            <ListBoxSelectWithImage :options="typeMaterialFinish" v-model="form.typeMaterialFinishCNC"
                labelMain="Finish Type" requires="True" />

            <ListBoxSelectWithImage v-if="form.typeMaterialFinishCNC == `Bare-Metal Finish`"
                :options="typeMaterialFinishBareMetal" v-model="form.typeMaterialFinishType"
                placeholder="Select Option" />

            <ListBoxSelectWithImage v-if="form.typeMaterialFinishCNC == `Powdercoat Finish`"
                :options="typeMaterialFinishPowderCoat" v-model="form.typeMaterialFinishType"
                placeholder="Select Option" />


            <BaseInput v-if="form.typeMaterialFinishType == 'Other'"
                label="Please indicate the powdercoat color you require"
                placeholder="Please indicate the powdercoat color you require" v-model="form.otherPowderCoat" />

        </div>

        <div v-if="(form.typeMaterialCnc == 'Aluminum' || form.typeMaterialCnc == 'Stainless Steel') && form.typeMaterialFinishCNC == 'Bare-Metal Finish'"
            class="my-3">


            <label for="comment" class="block text-sm font-medium text-gray-700"> Additional Finish Type </label>

            <div v-if="form.typeMaterialCnc == 'Aluminum'">
                <input type="checkbox" value="Chemical Conversion Coating" id="Chemical Conversion Coating"
                    class="h-4 w-4 mx-2 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                    v-model="form.typeMaterialFinishAdditionAluminum" />
                <label for="Chemical Conversion Coating">Chemical Conversion Coating</label>
                <input type="checkbox" value="Anodizing" id="Anodizing"
                    v-model="form.typeMaterialFinishAdditionAluminum"
                    class="h-4 w-4 mx-2 rounded border-gray-300 text-blue-600 focus:ring-blue-500" />
                <label for="Anodizing">Anodizing</label>
            </div>

            <!-- stainless steel finish type starts here -->
            <div v-if="form.typeMaterialCnc == 'Stainless Steel'">
                <input type="checkbox" value="Passivation" id="Passivation"
                    class="h-4 w-4 mx-2 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                    v-model="form.typeMaterialFinishAdditionStainlessSteel" />
                <label for="Passivation">Passivation</label>

            </div>

            <!-- stainless steel finish type ends here -->

        </div>

        <!-- Permanent Marking Options for all form.typeMaterialCnc except Other -->
        <BaseRadioButtonGroup :options="yesNo" v-model="form.reqPermanentMarking"
            label="Does your design require Permanent Marking? " requires="True" />
        <div v-if="form.typeMaterialCnc !== 'Other' && form.reqPermanentMarking == 'Yes'">

            <div class="my-3">
                <label for="comment" class="block text-sm font-medium text-gray-700 mb-2"> Which permanent marking are
                    you looking for? </label>
                <!-- if MaterialType is Aluminum Permanent Marking offerings are Laser Marking, Machined Engraving, Engrave and Fill, Quote All Options -->
                <div v-if="form.typeMaterialCnc == 'Aluminum'">
                    <input type="checkbox" value="Laser Marking" id="Laser Marking"
                        class="h-4 w-4 mx-2 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                        v-model="form.NewDesignSheetMetalPermanentMarking" />
                    <label for="Laser Marking">Laser Marking</label>
                    <input type="checkbox" value="Machined Engraving" id="Machined Engraving"
                        class="h-4 w-4 mx-2 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                        v-model="form.NewDesignSheetMetalPermanentMarking" />
                    <label for="Machined Engraving">Machined Engraving</label>
                    <input type="checkbox" value="Engrave and Fill" id="Engrave and Fill"
                        class="h-4 w-4 mx-2 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                        v-model="form.NewDesignSheetMetalPermanentMarking" />
                    <label for="Engrave and Fill">Engrave and Fill</label>
                    <input type="checkbox" value="Quote All Options" id="Quote All Options"
                        class="h-4 w-4 mx-2 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                        v-model="form.NewDesignSheetMetalPermanentMarking" />
                    <label for="Quote All Options">Quote All Options</label>
                </div>


                <!-- if MaterialType is Stainless Steel Permanent Marking offerings are Laser Marking, Machined Engraving,Quote All Options -->
                <div v-if="form.typeMaterialCnc == 'Stainless Steel'">
                    <input type="checkbox" value="Laser Marking" id="Laser Marking"
                        class="h-4 w-4 mx-2 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                        v-model="form.NewDesignSheetMetalPermanentMarking" />
                    <label for="Laser Marking">Laser Marking</label>
                    <input type="checkbox" value="Machined Engraving" id="Machined Engraving"
                        class="h-4 w-4 mx-2 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                        v-model="form.NewDesignSheetMetalPermanentMarking" />
                    <label for="Machined Engraving">Machined Engraving</label>
                    <input type="checkbox" value="Quote All Options" id="Quote All Options"
                        class="h-4 w-4 mx-2 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                        v-model="form.NewDesignSheetMetalPermanentMarking" />
                    <label for="Quote All Options">Quote All Options</label>
                </div>

                <!-- if MaterialType is Hot Rolled Steel,Cold Rolled Steel or Plastic then Permanent Marking offering is Machined Engraving -->
                <div v-if="form.typeMaterialCnc == 'Hot Rolled Steel' || form.typeMaterialCnc == 'Cold Rolled Steel' || form.typeMaterialCnc == 'Plastic'">
                    <input type="checkbox" value="Machined Engraving" id="Machined Engraving"
                        class="h-4 w-4 mx-2 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                        v-model="form.NewDesignSheetMetalPermanentMarking" />
                    <label for="Machined Engraving">Machined Engraving</label>
                </div>  





                
            </div>

            <div v-if="form.typeMaterialPermanentMarking == 'Other'">
                <BaseTextArea
                    label="Please tell us about the permanent marking you require. We can source material as a non-stock request, for additional leadtime and cost. "
                    v-model="form.typeMaterialPermanentMarkingOther" tooltip="We can source different material as a non-stock request
                    for additional leadtime and cost." />
            </div>

        </div>
    </div>

</template>

<script setup>
import { inject, ref, provide } from 'vue';

import BaseRadioButtonGroup from '../formComponents/BaseRadioButtonGroup.vue';
import ListBoxSelectWithImage from '../formComponents/ListBoxSelectWithImage.vue';
import BaseTextArea from '../formComponents/BaseTextArea.vue';
import { typeMaterialFinish, typeMaterialFinishBareMetal, typeMaterialFinishPowderCoat, typeMaterialAluminumOnly, typeMaterialStainlessSteelOnly } from '../../constants/finish'
import BaseInput from '../formComponents/BaseInput.vue';

const form = inject('form');

form.typeMaterialFinishAdditionAluminum = ref([]);
form.typeMaterialFinishAdditionStainlessSteel = ref([]);
form.NewDesignSheetMetalPermanentMarking = [];

const typeMaterialCnc =
    [
        {
            "id": 0, "title": "Aluminum"
        },
        {
            "id": 1, "title": "Cold Rolled Steel"
        },
        {
            "id": 2, "title": "Hot Rolled Steel"
        },
        {
            "id": 3, "title": "Stainless Steel"
        },
        {
            "id": 4, "title": "Plastic"
        },
        {
            "id": 5, "title": "Other"
        }

    ]

const typeMaterialCncAluminum =
    [


        { "id": 0, "title": "Rectangular Bar Stock" },
        { "id": 1, "title": "Round Bar Stock" },
        { "id": 2, "title": " Aluminum Sheet / Plate" },
        { "id": 3, "title": "MIC - 6 Plate" },
        { "id": 4, "title": "Structural Aluminum Angle" }

    ]

const typeMaterialCncColdRolledSteel =
    [
        { "id": 0, "title": "Round Bar Stock" },
    ]

const typeMaterialCncHotRolledSteel =
    [

        { "id": 0, "title": "Plate" },

    ]

const typeMaterialCncStainlessSteel =
    [
        { "id": 0, "title": "Rectangular Bar Stock" },

        { "id": 1, "title": "Round Bar Stock" },

    ]

const typeMaterialCncPlastic =
    [
        { "id": 0, "title": "Acrylic" },

        { "id": 1, "title": "Acetal" }, { "id": 2, "title": "UHMW" },

    ]

const yesNo = [
    { 'title': 'Yes' },
    { 'title': 'No' },
]


</script>